<p>course-by-teacher-detail works!</p>
